export default __webpack_public_path__ + "static/media/listing.2be46213.svg";